import { RouteConfig } from 'vue-router';
import redirectMastheadSearchToJobSearch from '@/router/guards/mastheadSearchGuard';

const jobSearchRoutes: RouteConfig[] = [
  {
    path: '/masthead_search',
    name: 'MastheadSearch',
    beforeEnter: redirectMastheadSearchToJobSearch,
  },
  {
    path: '/provider/jobs/search',
    name: 'JobSearch',
    component: () => import('@/apps/provider/jobs/search/JobSearch.vue'),
    meta: { shouldHideFooter: true },
  },
  {
    path: '/provider/jobs/details/:id',
    name: 'JobDetails',
    component: () => import('@/apps/provider/jobs/details/JobDetails.vue'),
    props: (route) => ({ jobId: route.params.id }),
    meta: { shouldHideFooter: true },
  },
  {
    path: '/provider/jobs/partner/:id',
    name: 'AdJobDetails',
    component: () => import('@/apps/provider/jobs/details/AdJobDetailsContainer.vue'),
    meta: { shouldHideFooter: true },
  },
];

export default jobSearchRoutes;
